import {
  type ChatAttachment,
  type ChatAttachmentApiResource,
  type ChatAttachmentInit,
  type ChatAttachmentInitApiResource,
  type ChatAttachmentInitPayload,
  type ChatConversation,
  type ChatConversationApiResource,
  type ChatMessage,
  type ChatMessageApiResource,
} from './chatApi.types';

const MEDIA_PREVIEW_TRANSLATION_KEY_BY_BACKEND_KEY: Record<string, string> = {
  'chat.preview.media_image': 'chat:preview.mediaImage',
  'chat.preview.media_video': 'chat:preview.mediaVideo',
  'chat.preview.media_document': 'chat:preview.mediaDocument',
};

export function mapApiResourceToChatConversation(
  resource: ChatConversationApiResource
): ChatConversation {
  return {
    id: resource.id,
    counterpartName: resource.counterpart_name,
    counterpartKind: resource.counterpart_kind,
    lastMessagePreview: resource.last_message_preview,
    lastMessageAt: resource.last_message_at,
    lastMessageSenderKind: resource.last_message_sender_kind,
    unreadCount: resource.unread_count,
    status: resource.status,
    isLocked: resource.is_locked,
  };
}

export function mapApiResourceToChatAttachment(
  resource: ChatAttachmentApiResource
): ChatAttachment {
  return {
    id: resource.id,
    filename: resource.filename,
    contentType: resource.content_type,
    sizeBytes: resource.size_bytes,
    width: resource.width,
    height: resource.height,
    mediaKind: resource.media_kind,
    status: resource.status,
    downloadUrl: resource.download_url,
    thumbnailUrl: resource.thumbnail_url,
  };
}

export function mapApiResourceToChatMessage(resource: ChatMessageApiResource): ChatMessage {
  return {
    id: resource.id,
    conversationId: resource.conversation_id,
    senderKind: resource.sender_kind,
    body: resource.body,
    attachments: resource.attachments.map(mapApiResourceToChatAttachment),
    createdAt: resource.created_at,
  };
}

export function mapApiResourceToChatAttachmentInit(
  resource: ChatAttachmentInitApiResource
): ChatAttachmentInit {
  return {
    attachmentId: resource.attachment_id,
    uploadUrl: resource.upload_url,
    contentType: resource.content_type,
    method: resource.method,
  };
}

export function mapChatAttachmentInitPayload(
  payload: ChatAttachmentInitPayload
): Record<string, unknown> {
  return {
    filename: payload.filename,
    content_type: payload.contentType,
    size_bytes: payload.sizeBytes,
  };
}

export function resolveLastMessagePreviewTranslationKey(preview: string | null): string | null {
  if (preview === null) {
    return null;
  }
  const translationKey = MEDIA_PREVIEW_TRANSLATION_KEY_BY_BACKEND_KEY[preview];
  return translationKey === undefined ? null : translationKey;
}

export function resolveMediaKindTranslationKey(mediaKind: string): string {
  if (mediaKind === 'image') {
    return 'chat:media.image';
  }
  if (mediaKind === 'video') {
    return 'chat:media.video';
  }
  return 'chat:media.document';
}
